<template>
    <div class="page-tabs-box">
        <el-tabs v-model="activeName" @tab-click="clickEvent">
            <el-tab-pane label="商品列表" name="1" link="/goodsManage/goods/list"></el-tab-pane>
            <el-tab-pane label="推荐商品列表" name="2" link="/goodsManage/goods/list2"></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    props:{
        name:{
            type: String,
            default: '1'
        }
    },
    data(){
        return{
            activeName: this.name
        }
    },
    methods:{
        clickEvent(tab){
            if (tab.$attrs.link) this.$router.push(tab.$attrs.link)
        }
    }
}
</script>